module.exports = __webpack_public_path__ + "static/media/CapstoneLogo2.9d96497c.png";